import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { ConfirmationComponent } from './confirmation.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LottieModule } from 'ngx-lottie';
@NgModule({
    declarations: [
        ConfirmationComponent
    ],
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        CommonModule,
        AngularSvgIconModule,
        LottieModule,
    ],
    exports: [
        ConfirmationComponent
    ]

})
export class ConfirmationModule {
}
